// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5749 ? "d8da785f" : chunkId) + "." + {"1452":"a3c27ef592e9e3e4","4693":"747ceb52e6c7ca9c","5208":"50295a20791d6425","5749":"d7b83de77d87bbd6"}[chunkId] + ".js";
};